import React from 'react';

import { formatNumber } from '@column/column-ui-kit';
import { cn } from '@column/ui';

interface TransferAmountProps extends React.ComponentProps<'span'> {
  amount?: number | null;
  currencyCode?: string;
  description?: string;
  badge?: React.ReactNode;
  isAdding?: boolean;
  signPlacement?: 'inline' | 'outside';
}

export const TransferAmount: React.FC<TransferAmountProps> = ({
  amount,
  className,
  children,
  currencyCode,
  description,
  badge,
  isAdding,
  signPlacement = 'outside',
  ...props
}) => {
  const amountContent =
    amount === undefined ? (
      children
    ) : amount === null ? (
      <span className="text-sm font-medium text-muted-foreground">-</span>
    ) : (
      formatNumber(amount, currencyCode)
    );

  const amountElement =
    amount === null ? (
      amountContent
    ) : (
      <span
        className={cn(
          'relative flex items-baseline gap-1 text-sm font-medium leading-[14px] tracking-normal',
          signPlacement === 'inline' && 'gap-0',
          isAdding === true && '[color:var(--color-seafoam-600)]',
          isAdding !== true && 'text-foreground',
          className
        )}
        {...props}
      >
        {isAdding === false && signPlacement === 'outside' && (
          <span className="absolute right-full top-[-1px] z-10 [font:inherit] [line-height:inherit]">-</span>
        )}
        {isAdding === false && signPlacement === 'inline' && <span>-</span>}
        {amountContent}
      </span>
    );

  if (description || amount !== undefined) {
    return (
      <div className="flex w-full min-w-0 max-w-full items-center gap-2 py-1">
        {amountElement}
        {description && (
          <span className="min-w-0 truncate text-xs font-normal text-muted-foreground">{description}</span>
        )}
        {badge}
      </div>
    );
  }

  return amountElement;
};
